import './Loader.css';

const Loader = ({ size = 'medium', fullScreen = false }) => {
  const loaderClasses = [
    'loader',
    `loader--${size}`,
    fullScreen && 'loader--fullscreen',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={loaderClasses}>
      <div className="loader-spinner" />
    </div>
  );
};

export default Loader;
